import { render, staticRenderFns } from "./produce_unique_code_detail.vue?vue&type=template&id=98244762&scoped=true"
import script from "./produce_unique_code_detail.vue?vue&type=script&lang=js"
export * from "./produce_unique_code_detail.vue?vue&type=script&lang=js"
import style0 from "./produce_unique_code_detail.vue?vue&type=style&index=0&id=98244762&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98244762",
  null
  
)

export default component.exports